export default __webpack_public_path__ + "static/media/noAppointmentSharing.35b63e4f.png";